import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic_clear_pic",
  "use": "icon-ic_clear_pic-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"icon-ic_clear_pic\"><g fill=\"none\" fill-rule=\"evenodd\"><circle fill=\"#707076\" opacity=\".8\" cx=\"18\" cy=\"18\" r=\"18\" /><path d=\"m9 9 18.028 18.028M9 27.028 27.028 9\" stroke=\"#FFF\" stroke-width=\"3\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol